<form [formGroup]="form.formGroup">
  <p-tabs value="0" (valueChange)="selectedTabChange.emit($event)">

    <p-tablist>
      <p-tab value="0">Operation Details
        @if (form.formGroup.controls.hydrocarbonFlow.invalid ||
            form.formGroup.controls.standardFluidFlow.invalid ||
            form.formGroup.controls.fluid.invalid ||
            form.formGroup.controls.pressure.invalid) {
          <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, double check inputs."></i>
        }
      </p-tab>
      @if (showLandingString && showRiser) {
        <p-tab value="1">Landing String
          @if (landingStringMissing) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Landing string not specified."></i>
          }
        </p-tab>
      }
      @if (showRiser) {
        <p-tab value="2">Riser
          @if (form.formGroup.controls?.insideDiameter.invalid || form.formGroup.controls?.outsideDiameter.invalid) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, some required inputs not specified."></i>
          }
        </p-tab>
      }
      @if (false && showOptionsAndNodal) {
        <p-tab value="3">Nodal
          @if (form.formGroup.controls.nodalAnalysis.invalid) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, double check Nodal inputs."></i>
          }
        </p-tab>
      }
      <p-tab value="4">Options
        @if (form.formGroup.controls.customEnthalpyOptions.invalid) {
          <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, double check Options."></i>
        }
      </p-tab>
    </p-tablist>

    <p-tabpanels class="pl-4 pr-2">

      <p-tabpanel value="0">

        <!-- Left Column -->
        <div class="flex flex-wrap gap-4">
          <div class="flex flex-col flex-1 min-w-[200px] space-y-2">

            <div class="flex flex-col">
              <label for="fluids">Fluid</label>
              <p-select filter filterBy="state.name" resetFilterOnHide="true" [disabled]="isReadOnly" [options]="fluids" [formControlName]="form.formControlNames.fluid"
                dataKey="id" appendTo="body" tooltipPosition="top" showDelay="100" hideDelay="500"
                (onChange)="fluidChangedEvent($event)"
                >
                <ng-template pTemplate="selectedItem">
                  {{ form.formGroup.value.fluid?.state.name }}
                </ng-template>
                <ng-template let-fluid pTemplate="item">
                  {{ fluid.state.name }}
                </ng-template>
              </p-select>
            </div>

            <div class="flex flex-col">
              <label for="perforation">Perforation</label>
              <p-select class="w-full" [title]="showJson(form.formGroup.value.perforation)"
                [options]="perforations" appendTo="body" [formControlName]="form.formControlNames.perforation" (onChange)="perfChange($event)"
                [disabled]="isReadOnly" [placeholder]="getPlaceholderText(form.formGroup.value.perforation)">
                <ng-template let-perforation pTemplate="selectedItem">
                  {{ getPlaceholderText(form.formGroup.value.perforation) }}
                </ng-template>
                <ng-template let-perforation pTemplate="item">
                  {{ perforation.name }}
                </ng-template>
              </p-select>
            </div>

            <div class="flex flex-col">
              <label for="tempAtPerfs">Temperature at Perfs</label>
              <p-inputgroup>
                @if (!includeNodalAnalysis) {
                  <p-inputNumber [minFractionDigits]="1" (onBlur)="updateTempAtPerfs()" id="pressure" [formControlName]="form.formControlNames.tempAtPerfs"></p-inputNumber>
                  <p-inputgroup-addon>{{ tempUnit }}</p-inputgroup-addon>
                }
                @if (includeNodalAnalysis) {
                  <input type="number" pInputText placeholder="Nodal Analysis Enabled" [disabled]="true" />
                }
              </p-inputgroup>
              @if (form.formGroup.controls.tempAtPerfs.value && form.formGroup.controls.tempAtPerfs.invalid) {
                <p class="validation-error">
                  Allowed range: {{ temperatureValidation.min }} -
                  {{ temperatureValidation.max }} {{ tempUnit }}
                </p>
              }
            </div>

            <div class="flex flex-col">
              <label for="pressure">Pressure Location</label>
              <p-inputgroup>
                @if (!includeNodalAnalysis) {
                  <p-select [disabled]="isReadOnly" [options]="pressureLocations"
                    [formControlName]="form.formControlNames.pressureLocation" optionLabel="name" optionValue="value"
                    appendTo="body" class="inputGroupDropdown">
                  </p-select>
                  <p-inputNumber [minFractionDigits]="1" id="pressure" [formControlName]="form.formControlNames.perforationPressure"></p-inputNumber>
                  <p-inputgroup-addon>{{ pressureUnit }}</p-inputgroup-addon>
                }
                @if (includeNodalAnalysis) {
                  <input type="number" pInputText placeholder="Nodal Analysis Enabled" [disabled]="true" />
                }
              </p-inputgroup>
              @if (form.formGroup.controls.perforationPressure.value && form.formGroup.controls.perforationPressure.invalid) {
                <p class="validation-error">
                  Allowed range: {{ pressureValidation.min }} -
                  {{ pressureValidation.max }} {{ pressureUnit }}
                </p>
              }
            </div>

            @if (isSubsea && currentTubularIndex > 0) {
            <div class="pt-3">
              <p-checkbox
                  size="small" 
                  [formControlName]="form.formControlNames.includeRiser"
                  inputId="includeRiser"
                  binary="true"
                  (onChange)="hasRiserChange();"
                ></p-checkbox>
                <label class="pl-2" for="includeRiser">Include Riser</label>
            </div>
            }
          </div>

          <!-- Right Column -->
          <div class="flex flex-col flex-1 min-w-[150px] space-y-2">
            @if (form.formGroup.value.fluid?.state.type === FluidType.BRINE ||
                form.formGroup.value.fluid?.state.type === FluidType.STANDARDMUD ||
                form.formGroup.value.fluid?.state.type === FluidType.ADVANCEDMUD) {
              <app-standard-fluid [formControlName]="form.formControlNames.standardFluidFlow" [userUnits]="userUnits">
              </app-standard-fluid>
            } @else if (form.formGroup.value.fluid?.state.type === FluidType.BLACKOIL ||
                form.formGroup.value.fluid?.state.type === FluidType.HYDROCARBON ||
                form.formGroup.value.fluid?.state.type === FluidType.VLE ||
                form.formGroup.value.fluid?.state.type === FluidType.CO2FLUID) {
              <app-hydrocarbon-fluid [userUnits]="userUnits" [isReadOnly]="isReadOnly"
                [formControlName]="form.formControlNames.hydrocarbonFlow"
                [selectedFluid]="form.formGroup.value.fluid"></app-hydrocarbon-fluid>
            }
          </div>

        </div>
      </p-tabpanel>

      <p-tabpanel value="1">
        <p class="{{ landingStringMissing ? 'validation-error' : '' }}">{{ selectedLandingString }}</p>
      </p-tabpanel>

      <p-tabpanel value="2">

        <p-fieldset legend="Riser">
          <div class="space-y-2">
            <div class="flex flex-col">
              <label for="outsideDiameter">Outside Diameter</label>
              <p-inputgroup>
                <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.outsideDiameter" />
                <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
              </p-inputgroup>
            </div>

            <div class="flex flex-col">
              <label for="outsideDiameter">Inside Diameter</label>
              <p-inputgroup>
                <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.insideDiameter" />
                <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
              </p-inputgroup>
            </div>
          </div>
        </p-fieldset>

      </p-tabpanel>

      <p-tabpanel value="3">

        <p-fieldset>
          <ng-template pTemplate="header">
            <div class="flex items-center">
              <input
                type="checkbox"
                binary="true"
                [checked]="includeNodalAnalysis"
                (change)="includeNodalAnalysisChange($event)"
                id="includeNodalAnalysis"
              >
              <label class="pl-2" for="includeNodalAnalysis">Nodal Analysis</label>
            </div>
          </ng-template>

          <app-nodal-analysis [disableNodal]="!includeNodalAnalysis"
            [formControlName]="form.formControlNames.nodalAnalysis" [reservoirs]="reservoirs" [chokes]="chokes"
            [userUnits]="userUnits" [pressureValidation]="pressureValidation"
            [temperatureValidation]="temperatureValidation" [pressureLabel]="'Flow Line Pressure'"
            [temperatureLabel]="'Flow Line Temperature'"
            [defaultTemperature]="surfaceTemperature"></app-nodal-analysis>

        </p-fieldset>
      </p-tabpanel>

      <p-tabpanel value="4">

        <div class="grid">
          <div class="col">

            <p-fieldset>
              <ng-template pTemplate="header">
                <div class="flex items-center space-x-2">
                  <input type="radio" binary="true" id="internalDefaults"
                    (click)="enthalpyOptionsChange('internalDefaults')"
                    [checked]="form.formGroup.controls.enthalpyOptionsSource.value === 'internalDefaults'">
                  <label for="internalDefaults">Internal Defaults</label>

                </div>
              </ng-template>

              <label style="padding-left: 10px;">Successive Relaxation Factor: 0.3</label>
              <br>
              <label style="padding-left: 10px;">Latent Heat Damping Factor: 100.0</label>
              <br>
              <label style="padding-left: 10px;">Latent Heat of Phase Change: OFF</label>

            </p-fieldset>

            <br>

            <p-fieldset>

              <ng-template pTemplate="header">
                <div class="flex items-center space-x-2">
                  <input type="radio" binary="true" id="newDefaults"
                    (click)="enthalpyOptionsChange('newDefaults')"
                    [checked]="form.formGroup.controls.enthalpyOptionsSource.value === 'newDefaults'">
                  <label for="newDefaults">New Defaults (PERICAL Options)</label>

                </div>
              </ng-template>

              <label style="padding-left: 10px;">Successive Relaxation Factor: {{
                pericalOptions.successiveRelationFactor }}</label>
              <br>
              <label style="padding-left: 10px;">Latent Heat Damping Factor: {{ pericalOptions.latentHeatDampingFactor
                }}</label>
              <br>
              <label style="padding-left: 10px;">Latent Heat of Phase Change: {{
                pericalOptions.includeLatentHeatPhaseChange == true ? 'ON' : 'OFF' }}</label>

            </p-fieldset>

            <br>

            <p-fieldset>

              <ng-template pTemplate="header">
                <div class="flex items-center space-x-2">
                  <input type="radio" binary="true" id="custom"
                    (click)="enthalpyOptionsChange('custom')"
                    [checked]="form.formGroup.controls.enthalpyOptionsSource.value === 'custom'">
                  <label for="custom">Use Custom Energy & Enthalpy Options</label>
                </div>
              </ng-template>

              <app-enthalpy-options [formControlName]="form.formControlNames.customEnthalpyOptions"
                [disableCustomOptions]="form.formGroup.controls.enthalpyOptionsSource.value !== 'custom'"></app-enthalpy-options>
            </p-fieldset>

          </div>
        </div>

      </p-tabpanel>

    </p-tabpanels>

  </p-tabs>
</form>